// Selectors
import { getCurrentFocus } from './focusSelector';

// Constants
import { SET_FOCUS_SECTION } from './focusConstants';

export const setFocusSection = (section) => (dispatch, getState) => {
    const state = getState();

    if (getCurrentFocus(state) === section) return;
    return dispatch({ type: SET_FOCUS_SECTION, section });
};
